import {
  Box,
  HStack,
  Text,
  TabPanel,
  Tabs,
  Tab,
  TabList,
  TabPanels,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  //Spacer,
  //useToast,
} from "@chakra-ui/react";
import { CoachStats } from "../CoachStats";
import { MdOutlineBook, MdOutlineQueryStats } from "react-icons/md";
import { CoachNextTrainings } from "../CoachNextTrainings";
import { ModalNewCoach } from "./ModalNewCoach";
//import { HiOutlineRefresh } from "react-icons/hi";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
//import { MdAdd } from "react-icons/md";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useState /*useEffect*/ } from "react";
//import axios from "axios";

export function AdminCoaches({ coachesList }) {
  const [coach, setCoach] = useState(0);
  const [newCoach, setNewCoach] = useState(false);
  const [users /*, setUsers*/] = useState([]);
  //const toast = useToast(); // to display toasts

  /*useEffect(() => {
    (async () => {
      //setIsLoading(true);

      await axios
        .get("/api/admin/users")
        .then((response) => {
          setUsers(response.data);
        })
        .catch((error) => {
          toast({
            title: "¡Error inesperado!",
            description: error.message,
            status: "error",
            position: "bottom-right",
            duration: 3000,
            isClosable: true,
          });
        });

      //setIsLoading(false);
    })();
  }, [toast]);*/

  return (
    <>
      <ModalNewCoach
        isOpen={newCoach}
        onClose={() => setNewCoach(false)}
        usersList={users}
        bonoTypesList={null}
        returnFocusOnClose={false}
      />
      {/*
      <Box
        width={{ base: "90%", sm: "90%", md: "80%" }}
        margin="auto"
        maxW="1300px"
      >
        <HStack display="flex" justifyContent="space-between">
          <Spacer />

          <HStack spacing={-3} mr={-2}>
            <Button
              title="Añadir nuevo bono"
              variant="ghost"
              colorScheme="black"
              size={{ base: "sm", sm: "sm", md: "md" }}
              fontWeight={400}
              px={"0px !important"}
              onClick={() => setNewCoach(true)}
            >
              <MdAdd size="1.25em" />
            </Button>
          </HStack>
        </HStack>
      </Box>
*/}

      <Box
        width={{ base: "100%", sm: "100%", md: "80%" }}
        margin="auto"
        maxW="1300px"
      >
        <HStack justifyContent="space-between" mb={-1} mx={{ md: -4 }}>
          <Button
            id="prev"
            background="transparent"
            _hover={{ bg: "transparent" }}
            isDisabled={coach === 0}
            onClick={() => setCoach(coach - 1)}
            aria-label="Semana anterior"
          >
            <GoChevronLeft />
          </Button>
          <Menu placement="bottom">
            <MenuButton size="sm" mr={-1}>
              {coachesList[coach].coachName + " "}
              <ChevronDownIcon />
            </MenuButton>
            <MenuList borderRadius={0} minW="80px">
              {coachesList.map((coach, index) => (
                <MenuItem onClick={() => setCoach(index)}>
                  {coach.coachName}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>

          <Button
            id="next"
            isDisabled={coach === coachesList.length - 1}
            onClick={() => setCoach(coach + 1)}
            background="transparent"
            _hover={{ bg: "transparent" }}
            aria-label="Semana siguiente"
          >
            <GoChevronRight />
          </Button>
        </HStack>

        <Tabs isFitted isLazy lazyBehavior="keepMounted" mt={1}>
          <TabList width={"100%"} maxW="1300px" m="auto">
            <Tab>
              <MdOutlineQueryStats />
              <Text display={{ base: "none", sm: "none", md: "flex" }}>
                &nbsp;Estadísticas
              </Text>
            </Tab>
            <Tab>
              <MdOutlineBook />
              <Text display={{ base: "none", sm: "none", md: "flex" }}>
                &nbsp;Reservas
              </Text>
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel className="p0-tab-panel pb0-tab-panel ">
              <CoachStats
                coachId={coachesList[coach].coachId}
                coachPayRate={coachesList[coach].payRate}
              />
            </TabPanel>
            <TabPanel className="p0-tab-panel pb0-tab-panel">
              <CoachNextTrainings coachId={coachesList[coach].coachId} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  );
}
